module.exports = __webpack_public_path__ + "img/bg01.bfd4ac61.jpg";